<template>
  <div class="footerComponent">
    <div>
      Copyright © 2021-2025 极智科技（山东）有限公司 All Rights Reserved.
    </div>
    <div>ICP备案：鲁ICP备20013547号</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footerComponent {
  padding: 20px;
  border-top: 1px solid #e2e8f0;
  background: #f1f5f94d;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}
</style>
